import { createApi } from '@stilingue/st-auth-utils';
import Service from './Service';
import { error401Handler } from '@/utils/error';
import { displaceDateRange } from '@/utils/url';
import merge from 'lodash/merge';

const gateway = process.env.VUE_APP_SERVICES_PROXY_URL || '';

const afterParser = (response) => {
  return response.data;
};

class WarRoomService extends Service {
  constructor(gateway) {
    const api = createApi('/', gateway, {
      authNotFound: () => true,
      error401Handler,
    });

    super(api, {
      afterParser,
      retriesLimit: 10,
    });

    this.api.http.defaults.timeout = 600000;
  }

  getDistributionMedia(params = {}) {
    return this.find({
      ...params,
      url: 'distribution/media_type',
    });
  }

  getFeaturedMedia(params = {}) {
    return this.find({
      ...params,
      url: 'featured_midia',
    });
  }

  getpublicitaryValoration(params = {}) {
    return this.find({
      ...params,
      url: 'publicitary_valoration',
    });
  }

  async getpublicitaryValorationWithVariation({ params = {} }) {
    const { originalParams, displacedParams } = displaceDateRange(params);
    const [data, displacedData] = await Promise.all([
      this.getpublicitaryValoration({ params: originalParams }),
      this.getpublicitaryValoration({ params: displacedParams }),
    ]);

    const previous_data = {
      data: {
        equivalence: {
          previous_value: displacedData.data.equivalence.value,
        },
      },
    };

    return merge({}, { ...data }, previous_data);
  }
}

export default new WarRoomService(gateway);
